import { Check } from "lucide-react";

const PORTRAIT = "/images/isi.jpg";

const VALUES = [
  "Productos premium e hipoalergénicos",
  "Esterilización de grado clínico en cada sesión",
  "Diseños personalizados: nunca repito un set",
  "Puntualidad y trato cálido, como en casa",
];

export default function About() {
  return (
    <section id="sobre-mi" data-testid="about-section" className="py-16 sm:py-24 lg:py-32 bg-creamcard">
      <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="relative order-2 lg:order-1">
          <div className="absolute -top-5 -right-5 w-full h-full rounded-3xl border-2 border-gold/40" />
          <img
            src={PORTRAIT}
            alt="Isis, nail artist"
            data-testid="about-portrait"
            className="relative rounded-3xl w-full h-[420px] sm:h-[500px] object-cover object-top shadow-xl shadow-gold/10"
          />
          <div className="absolute -bottom-6 left-6 backdrop-blur-xl bg-white/90 border border-amber-900/10 rounded-2xl px-6 py-4 shadow-lg">
            <p className="font-display italic text-lg text-obsidian">"El detalle es mi idioma"</p>
          </div>
        </div>

        <div className="order-1 lg:order-2 max-w-xl">
          <p className="text-xs sm:text-sm tracking-[0.3em] uppercase text-gold font-medium">03 · Sobre Mí</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-obsidian mt-4">
            Quién está detrás de ISI'S Nails
          </h2>
          <p className="text-sm sm:text-base text-taupe leading-relaxed mt-6">
            Detrás de cada set hay una persona: soy Isis, nail artist venezolana.
            Crecí rodeada del color de los atardeceres caribeños y de una cultura
            donde cuidar los detalles es una forma de cariño. Esa paleta cálida
            —los dorados, los rosas, la luz del Caribe— vive hoy en cada uno de
            mis diseños.
          </p>
          <p className="text-sm sm:text-base text-taupe leading-relaxed mt-4">
            Para mí, tus manos son un lienzo. Trabajo cada set con calma, precisión
            y muchísimo cariño, porque sé que unas uñas hermosas cambian cómo te
            sientes frente al espejo.
          </p>
          <ul className="mt-8 space-y-3">
            {VALUES.map((v) => (
              <li key={v} className="flex items-start gap-3 text-sm sm:text-base text-cocoa">
                <span className="mt-0.5 w-5 h-5 rounded-full bg-gold/15 flex items-center justify-center shrink-0">
                  <Check className="w-3 h-3 text-gold" />
                </span>
                {v}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
